import get from 'lodash/get';
import {
  AppAdapter,
  UserInfoFields,
  RegistrationCompleteArgs
} from './AppAdapter';

export default class IOSAdapter implements AppAdapter {
  messageHandlers: Record<string, Record<'postMessage', typeof Object>> | null;

  constructor() {
    this.messageHandlers = get(window, 'webkit.messageHandlers', null);
  }

  setUserInfo(userInfo: Record<UserInfoFields, string>): void {
    try {
      if (this.messageHandlers) {
        this.messageHandlers.setUserInfo.postMessage(userInfo);
      }
    } catch (err) {
      this.registrationFailed(err as Error);
      throw err;
    }
  }

  registrationComplete(fundingInfo: RegistrationCompleteArgs): void {
    try {
      if (this.messageHandlers) {
        this.messageHandlers.registrationComplete.postMessage(fundingInfo);
      }
    } catch (err) {
      this.registrationFailed(err as Error);
      throw err;
    }
  }

  registrationFailed(error?: Error): void {
    try {
      if (this.messageHandlers) {
        this.messageHandlers.registrationFailed.postMessage(
          error?.message || 'Failure'
        );
      }
    } catch (err) {
      throw err;
    }
  }

  registrationReAuth(): void {
    try {
      if (this.messageHandlers) {
        this.messageHandlers.registrationReAuth.postMessage('ReAuth');
      }
    } catch (err) {
      this.registrationFailed(err as Error);
      throw err;
    }
  }

  launchNativePlaidFlow(): void {
    try {
      if (this.messageHandlers && this.messageHandlers.launchNativePlaidFlow) {
        this.messageHandlers.launchNativePlaidFlow.postMessage(
          'launchNativePlaidFlow'
        );
      }
    } catch (err) {
      this.registrationFailed(err as Error);
      throw err;
    }
  }
}
